import { safeDefine } from "../../registration/safe-define.js";
import { DialogElement } from "../../ui/dialog/element.js";
//#region src/define/ui/dialog.ts
safeDefine(DialogElement);
//#endregion
